import React from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";

function Sidebar({ listCategoriesNum, setListCategoriesNum }: any) {
  const navigate = useNavigate();

  const toggleSubcategories = (index: any) => {
    setListCategoriesNum((listCategoriesNum: any) =>
      listCategoriesNum?.map((category: any, i: any) =>
        i === index
          ? { ...category, isExpanded: !category?.isExpanded }
          : category,
      ),
    );
  };

  const categoryTotalCount = (subCategories: any) => {
    return subCategories.reduce(
      (total: number, sub: any) => total + (sub?.productCount || 0),
      0,
    );
  };

  return (
    <aside className="sidebar">
      <h3 className="sidebar-title">Catégories</h3>
      <ul className="category-list">
        {listCategoriesNum.map((category: any, index: any) => (
          <li key={index} className="category-item">
            <div
              className="category-header"
              onClick={() => toggleSubcategories(index)}
            >
              {category.categoryName} (
              {categoryTotalCount(category?.subCategories)})
            </div>
            {category.isExpanded && (
              <ul className="subcategory-list">
                {category.subCategories.map((sub: any, subIndex: any) => (
                  <li
                    key={subIndex}
                    className="subcategory-item"
                    onClick={() =>
                      navigate(`/sub-category/${sub?.subCategoryId}`)
                    }
                  >
                    {sub?.subCategoryName}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;
